<div nxModalContent>
  <div class="gdpr-modal">
    <qbe-illustration class="gdpr-modal--illustration nx-margin-bottom-m" name="clientAndAgentShakingHands" />
    <ng-container *ngIf="isAppAgentOrTravelAgency; else direct">
      <h3 nxHeadline="subsection-large" class="u-text-center nx-margin-bottom-m">{{ 'modals.gdpr.agent.title' | translate }}</h3>
      <p nxCopytext="normal" [innerHTML]="'modals.gdpr.agent.content' | translate | markdown"></p>
    </ng-container>
  </div>
</div>

<ng-template #direct>
  <h3 nxHeadline="subsection-large" class="u-text-center nx-margin-bottom-m">{{ 'modals.gdpr.title' | translate }}</h3>

  <div class="nx-margin-bottom-m">
    <h4 class="nx-margin-bottom-2xs" nxHeadline="subsection-small">
      {{ 'modals.gdpr.sub-title' | translate }}
    </h4>
    <p nxCopytext="normal" [innerHTML]="'modals.gdpr.content' | translate | markdown"></p>
  </div>

  <div class="nx-margin-bottom-m">
    <h4 class="nx-margin-bottom-2xs" nxHeadline="subsection-small">
      {{ 'modals.gdpr.sub-title2' | translate }}
    </h4>
    <p nxCopytext="normal" [innerHTML]="'modals.gdpr.content2' | translate | markdown"></p>
  </div>

  <div class="nx-margin-bottom-2xs">
    <h4 class="nx-margin-bottom-2xs" nxHeadline="subsection-small">
      {{ 'modals.gdpr.sub-title3' | translate }}
    </h4>
    <p nxCopytext="normal" [innerHTML]="'modals.gdpr.content3' | translate | markdown"></p>
  </div>
</ng-template>
